import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader } from "../components/PageHeader";
import { Loader, EmptyState, Btn } from "../components/Primitives";
import { Bell, CircleCheck } from "lucide-react";
import { toast } from "sonner";

const SEVERITY = {
  info: "border-blue-200 bg-blue-50 text-blue-900",
  warning: "border-amber-200 bg-amber-50 text-amber-900",
  critical: "border-red-200 bg-red-50 text-red-900",
};

export default function Notifications() {
  const [items, setItems] = useState(null);

  const load = async () => {
    const { data } = await api.get("/notifications");
    setItems(Array.isArray(data) ? data : (data.items || []));
  };
  useEffect(() => { load(); }, []);

  const markRead = async (n) => {
    await api.post(`/notifications/${n.id}/read`);
    load();
  };

  if (!items) return <Loader />;

  return (
    <div>
      <PageHeader
        title="Notifications"
        description="Alerts across breach cases, requests, tasks, deadlines, and vendor reviews."
        testId="notifications-page-header"
      />

      {items.length === 0 ? <EmptyState title="No notifications" hint="You are all caught up." /> : (
        <div className="space-y-2" data-testid="notifications-list">
          {items.map((n) => {
            const cls = SEVERITY[n.severity] || SEVERITY.info;
            return (
              <div key={n.id} className={`border rounded-md p-4 flex items-start gap-3 ${cls} ${n.read ? "opacity-70" : ""}`}>
                <Bell className="w-4 h-4 shrink-0 mt-0.5" />
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold">{n.title}</div>
                  <div className="text-xs mt-1">{n.message}</div>
                  <div className="text-[10px] uppercase tracking-wider mt-2 opacity-70">{n.created_at?.slice(0, 19).replace("T", " ")}</div>
                </div>
                <div className="flex flex-col gap-1 items-end">
                  {n.link && <a href={n.link} className="text-[11px] font-semibold hover:underline">Open →</a>}
                  {!n.read && (
                    <button data-testid={`notification-read-${n.id}`} onClick={() => markRead(n)} className="text-[11px] font-semibold flex items-center gap-1 hover:underline">
                      <CircleCheck className="w-3 h-3" /> Mark read
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
